import React, { useEffect, useState } from "react";
import { ExternalLink, CalendarDays } from "lucide-react";
import { fetchArticles } from "../lib/articlesApi";

function formatDate(date) {
  try {
    return new Date(date).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric"
    });
  } catch {
    return date || "";
  }
}

export function ConteudoPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;
    fetchArticles()
      .then((items) => {
        if (!active) return;
        setArticles(items);
      })
      .catch((err) => {
        if (!active) return;
        setError(err.message);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <main className="min-h-screen bg-[#faf9f7] pt-28 sm:pt-36 pb-16 sm:pb-20 border-t border-[#d4af37]/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        <div className="max-w-3xl mb-8 sm:mb-12">
          <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl text-[#1a1a1a] mb-3 sm:mb-4">Fórum Jurídico</h1>
          <p className="text-slate-600 text-sm sm:text-base">
            Artigos e atualizações jurídicas de fontes externas, organizados do mais recente para o mais antigo.
          </p>
        </div>

        {loading && <p className="text-slate-500">Carregando artigos...</p>}
        {error && <p className="text-red-600">{error}</p>}

        {!loading && !error && (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {articles.map((article) => (
              <article
                key={article.id}
                className="bg-white rounded-xl border border-[#d4af37]/15 shadow-sm p-5 sm:p-6 flex flex-col"
              >
                <span className="inline-flex w-fit px-3 py-1 rounded-full text-xs font-semibold bg-[#d4af37]/15 text-[#8a6a14] mb-4">
                  {article.category}
                </span>
                <h2 className="font-serif text-xl text-[#1a1a1a] mb-3">{article.title}</h2>
                <p className="text-slate-600 text-sm leading-relaxed mb-6 flex-1">{article.summary}</p>
                <div className="flex items-center justify-between gap-3 border-t border-slate-100 pt-4">
                  <span className="inline-flex items-center gap-1 text-xs text-slate-500">
                    <CalendarDays className="w-4 h-4" />
                    {formatDate(article.publishedAt)}
                  </span>
                  <a
                    href={article.sourceUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 text-sm font-medium text-[#b8962e] hover:text-[#8a6a14]"
                  >
                    Ler fonte
                    <ExternalLink className="w-4 h-4" />
                  </a>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </main>
  );
}
